import * as actionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsOpenState */

/** @type {IsOpenState} */
const initialState = null;

const set = (_, { payload }) => payload.checklistGroupId ?? initialState;
const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.OPEN_CHECKLISTS_IMPORT_MODAL]: set,
  [actionTypes.CLOSE_CHECKLISTS_IMPORT_MODAL]: reset,
});
